// src/utils/apiHelpers.js

export const makeApiCall = async (url, method, body) => {
  const response = await fetch(url, {
    method,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("authentication/token")}`,
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    throw new Error(`Failed to ${method} request.`);
  }

  return response.json();
};
